import axios from 'axios';
import { IdVersion, RelazioneMedicaEventoCreateCommand, RelazioneMedicaEventoUpdateCommand, RelazioneMedicaEvento } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/relazione-medica-eventi';

export const getByKey = async (id: number): Promise<RelazioneMedicaEvento> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};
export const getByRelazioneMedica = async (id: number): Promise<RelazioneMedicaEvento[]> => {
    return (await axios.get(`${baseUrl}/relazione-medica/${id}`)).data;
};

export const create = async (command: RelazioneMedicaEventoCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: RelazioneMedicaEventoUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};
